module.exports = __webpack_public_path__ + "assets/img/Clementi Mall.003bd8c7.jpg";